import React from 'react';
import { Link } from 'react-router-dom';
import ai from '../assets/images/ai.svg';
import md from '../assets/images/md.svg';
import si from '../assets/images/si.svg';
import ob from '../assets/images/okas_main_hover.svg';
// import distributor from '../assets/images/Distributor_hover.svg';
import distributor from '../assets/images/distributor_gray.svg';
import distributorHover from '../assets/images/distributorsHover.svg';
import aiHover from '../assets/images/ai-hover.svg';
import mdHover from '../assets/images/md-hover.svg';
import siHover from '../assets/images/si-hover.svg';
import obHover from '../assets/images/okas_main.svg';
import totalDevices from '../assets/images/totalDevices.svg';
import totalSI from '../assets/images/totalSI.svg';
import totalBoxes from '../assets/images/totalBoxes.svg';
import totalProjects from '../assets/images/totalProjects.svg';
// import PieChart from '../components/PieChart';
import DoughnutChart from '../components/DoughnutChart';
// import DropDown from '../components/DropDown';
import '../css/Dashboard.css';
// import { Dropdown } from 'antd';
// import Cookies from 'js-cookie';
import * as ActionTypes from '../actions/types';
import PieChartNew from '../components/PieChartNew';
import { is_allowed } from '../utilitis';
import { connect } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';


//dashboard of the okas.ai 
class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            siImg: si,
            mdImg: md,
            aiImg: ai,
            obImg: ob,
            distributorImg: distributor,
            siHeading: 'logo-dashboard',
            mdHeading: 'logo-dashboard',
            aiHeading: 'logo-dashboard',
            obHeading: 'logo-dashboard',
            distributorHeading: 'logo-dashboard',
            ticketList: [],
            totalDevices: 0,
            totalSI: 0,
            totalBoxes: 0,
            totalProjects: 0,
            screenSize: window.innerWidth,
            publicVersion: '--',
            versionData: []
        }
    }


    hoverEffectEnter = (hoverType) => {
        if (hoverType === 'si') {
            this.setState({
                siImg: siHover,
                siHeading: 'link-heading'
            })
        } else if (hoverType === 'md') {
            this.setState({
                mdImg: mdHover,
                mdHeading: 'link-heading'
            })
        } else if (hoverType === 'ai') {
            this.setState({
                aiImg: aiHover,
                aiHeading: 'link-heading'
            })
        } else if (hoverType === 'ob') {
            this.setState({
                obImg: obHover,
                obHeading: 'link-heading'
            })
        }
        else if (hoverType === 'distributor') {
            this.setState({
                distributorImg: distributorHover,
                distributorHeading: 'link-heading'
            })
        }
    }

    hoverEffectLeave = (hoverType) => {
        if (hoverType === 'si') {
            this.setState({
                siImg: si,
                siHeading: 'logo-dashboard'
            })
        } else if (hoverType === 'md') {
            this.setState({
                mdImg: md,
                mdHeading: 'logo-dashboard'
            })
        } else if (hoverType === 'ai') {
            this.setState({
                aiImg: ai,
                aiHeading: 'logo-dashboard'
            })
        } else if (hoverType === 'ob') {
            this.setState({
                obImg: ob,
                obHeading: 'logo-dashboard'
            })
        } else if (hoverType === 'distributor') {
            this.setState({
                distributorImg: distributor,
                distributorHeading: 'logo-dashboard'
            })
        }
    }

    fetchTickets = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/ticketdata/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
               // console.log(data);
                this.setState({
                    ticketList: data
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    fetchVersion = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/versioncontrol/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                console.log(data)
                this.setState({
                    versionData: data
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }


    fetchBoxes = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/okasBoxApi/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                this.setState({
                    totalBoxes: data.length,
                })
                // console.log(data.length)
            })
            .catch((err) => {
                console.log(err)
            })
    }
    fetchProjects = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/total_projects/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                this.setState({
                    totalProjects: data.count,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    fetchDevices = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/device_cloudApi/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                this.setState({
                    totalDevices: data.length
                })
                // console.log(this.state.totalDevices)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    fetchSI = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/si_IntegratorApi/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                this.setState({
                    totalSI: data.length,
                })
            })
            .catch((err) => {
                console.log(err)

            })
    }
    componentDidMount() {
        // this.fetchTickets();
        this.fetchBoxes();
        this.fetchDevices()
        this.fetchSI();
        this.fetchProjects();
       // console.log(this.props)
    }

    componentWillMount() {
        this.fetchPublicVersion();
        this.fetchInternalVersion();

    }


    dashboardChart = () => {

        let totalDevicesIcon = <img src={totalDevices} />;
        let totalSIIcon = <img src={totalSI} />;
        let totalBoxesIcon = <img src={totalBoxes} />;
        let totalProjectsIcon = <img src={totalProjects} />;
        return (
            <div className="card-custom-height">
                <div className="dashboard-card-heading" style={{ marginBottom: '10px' }}>DASHBOARD OVERVIEW</div>
                <div className="custom-card-dashboard" style={{ borderRadius: "15px 15px 15px 15px", height: '43vh' }}>
                    <div className="d-flex h-100" >
                
                        <div className="flex-fill text-center my-auto">
                            {/* {is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "okas inventory", "assign okas inventory") && */}

                                <PieChartNew
                                    percent={this.state.totalBoxes}
                                    chartWidth={window.screen.availWidth / 12}
                                    displayBackgroundColor='white'
                                    strokeWidth={6.5}
                                    icon={totalBoxesIcon}
                                    label="OKAS Inventory"
                                    strokeColor='#f07e25'
                                    // percentLabel="Boxes"
                                    percentFontSize={`${window.screen.availWidth / 750}rem`}
                                    percentLabelSize={`${window.screen.availWidth / 2220}rem`}
                                    percentLabelTop="60%"
                                    percentTop="30%"
                                    fontWeight="650"
                                />
                                {/* } */}
                        </div>
                        <div className="flex-fill text-center my-auto" >
                            <PieChartNew
                                percent={this.state.totalSI}
                                chartWidth={window.screen.availWidth / 12}
                                displayBackgroundColor='white'
                                strokeWidth={6.5}
                                icon={totalSIIcon}
                                label="Total SI"
                                strokeColor='#f07e25'
                                // percentLabel="SI"
                                percentFontSize={`${window.screen.availWidth / 750}rem`}
                                percentLabelSize={`${window.screen.availWidth / 2220}rem`}
                                percentLabelTop="60%"
                                percentTop="30%"
                                fontWeight="650"
                            />
                        </div>
                        <div className="flex-fill text-center my-auto">
                            <PieChartNew
                                percent={this.state.totalProjects}
                                chartWidth={window.screen.availWidth / 12}
                                displayBackgroundColor='white'
                                strokeWidth={6.5}
                                icon={totalProjectsIcon}
                                label="Total Projects"
                                strokeColor='#f07e25'
                                // percentLabel="Projects"
                                percentFontSize={`${window.screen.availWidth / 750}rem`}
                                percentLabelSize={`${window.screen.availWidth / 2220}rem`}
                                percentLabelTop="60%"
                                percentTop="30%"
                                fontWeight="650"
                            />
                        </div>
                        <div className="flex-fill text-center my-auto">
                            <PieChartNew
                                percent={this.state.totalDevices}
                                chartWidth={window.screen.availWidth / 12}
                                displayBackgroundColor='white'
                                strokeWidth={6.5}
                                icon={totalDevicesIcon}
                                label="Total Devices"
                                strokeColor='#f07e25'
                                // percentLabel="Devices"
                                percentFontSize={`${window.screen.availWidth / 750}rem`}
                                percentLabelSize={`${window.screen.availWidth / 2220}rem`}
                                percentLabelTop="60%"
                                percentTop="30%"
                                fontWeight="650"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    recentTickets = () => {
        let totalDevicesIcon = <img src={totalDevices} />;
        let totalSIIcon = <img src={totalSI} />;
        let totalBoxesIcon = <img src={totalBoxes} />;
        let totalProjectsIcon = <img src={totalProjects} />;
        return (<div style={{ borderRadius: '0px 0px 15px 15px' }}>
            <div className="dashboard-card-heading">
                <span>RECENT SUPPORTS</span>
            </div>
            <thead style={{ backgroundColor: '#00b0a9', padding: '2%', color: 'white', borderRadius: "15px 15px 0px 0px" }}>
                <th style={{ width: '15%' }}>Ticket No</th>
                <th style={{ width: '71%' }}>Subject</th>
                <th style={{ width: '14%', padding: '0' }}>Action</th>
            </thead>
            <div className="custom-card-dashboard" style={{ borderRadius: "0px 0px 15px 15px" }}>
                <table className="table table-striped dashboard-internal-table" style={{ borderRadius: "0px 0px 15px 15px" }} >
                    <tbody style={{ height: '34vh', borderRadius: "0px 0px 15px 15px" }}>
                        {this.state.ticketList.map((firstElement) => {
                            return (
                                <tr>
                                    <td style={{ width: '15%', textAlign: 'left', paddingLeft: '2%' }}>{firstElement.ticket_id}</td>
                                    <td style={{ width: '70%' }}>
                                        {firstElement.subject}
                                    </td>
                                    <td style={{ width: '15%', textAlign: 'left', paddingLeft: '0px', color: '#00b0a9' }}>
                                        <Link to={{
                                            pathname: `/support/ticket/${firstElement.ticket_id}`,
                                            item: {
                                                ticket: `${firstElement.ticket_id}`
                                            }
                                        }} style={{ color: '#00b0a9', fontStyle: 'oblique' }}>
                                            Reply
                                        </Link>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>);
    }

    fetchPublicVersion = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/okasVersionApi/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                if (data.detail === 'Invalid token.') {
                    localStorage.clear();
                } else {
                    if (data.length === 0) {
                        this.setState({
                            publicVersion: '--'
                        })
                    } else {
                        this.setState({
                            publicVersion: data[0].major.okas_product_version
                        })
                    }
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    recentAddedSection = () => {
        return (<div style={{ height: '100%' }}>
            <div className="dashboard-card-heading">
                <span>RECENTLY ADDED</span>
                <span className="dashboard-card-heading float-right mr-2">
                    <div class="dropdown">
                        <button type="button" class="btn dropdown-toggle " data-toggle="dropdown" style={{ border: 'none', backgroundColor: 'transparent', color: 'black' }}>
                            Project
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item" href="#">OKAS Boxes</a>
                            <a class="dropdown-item" href="#">SI</a>
                            <a class="dropdown-item" href="#">Projects </a>
                            <a class="dropdown-item" href="#">Devices </a>
                        </div>
                    </div>
                </span>
            </div>
            <div className="ai-dashboard" style={{ borderRadius: '15px' }}>
                <table className="table table-striped" >
                    <tbody style={{ borderRadius: '0 0 15px 15px' }} >
                        <tr>
                            <td>Alison add a project john's house in New York</td>
                            <td>Detail</td>
                        </tr>
                        <tr>
                            <td>Alison add a project john's house in New York</td>
                            <td>Detail</td>
                        </tr>
                        <tr>
                            <td>Alison add a project john's house in New York</td>
                            <td>Detail</td>
                        </tr>
                        <tr>
                            <td>Alison add a project john's house in New York</td>
                            <td>Detail</td>
                        </tr>
                        <tr>
                            <td>Alison add a project john's house in New York</td>
                            <td>Detail</td>
                        </tr>
                        <tr>
                            <td>Alison add a project john's house in New York</td>
                            <td>Detail</td>
                        </tr>
                        <tr>
                            <td>Alison add a project john's house in New York</td>
                            <td>Detail</td>
                        </tr>
                        <tr>
                            <td>Alison add a project john's house in New York</td>
                            <td>Detail</td>
                        </tr>
                        <tr>
                            <td>Alison add a project john's house in New York</td>
                            <td>Detail</td>
                        </tr>
                        <tr>
                            <td>Alison add a project john's house in New York</td>
                            <td>Detail</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>);
    }

    versionSection = () => {
        return (<div style={{ height: '100%' }}>
            <div className="dashboard-card-heading" style={{ marginBottom: '10px' }}>
                <span>LATEST VERSIONS</span>
            </div>
            <div className="d-flex align-items-center" style={{ backgroundColor: '#f07e25', paddingTop: '1%', paddingBottom: '5%', color: 'white', borderRadius: "15px 15px 0px 0px" }}>
                <div className="d-flex  align-content-center w-100">
                    <div className="d-flex align-content-end" style={{ fontSize: '1.00rem' }}>
                        <span className="text-uppercase" style={{ paddingTop: "10%", marginLeft: '15px' }}>
                            Updated <br /> Product Version
                        </span>
                    </div>
                    <div className="ml-auto mr-4" style={{ fontSize: '2rem', fontWeight: '600', }}>{this.state.publicVersion}</div>
                </div>
            </div>
            <div className="ai-dashboard" style={{ borderRadius: '0 0 15px 15px', width: '100%', border: '1px solid white' }}>
                <table className="table" style={{ width: '100%', marginBottom: '1%', height: '180px', borderRadius: '0 0 15px 15px' }}>
                    <tbody style={{ height: '100%', width: '100%' }} >
                        <tr style={{ fontWeight: 'bold', marginTop: '2%', marginBottom: '2%', height: '4px' }}>
                            <span style={{ marginLeft: '15px' }}>
                                INTERNAL APPLICATIONS UPDATED VERSION
                            </span>
                        </tr>
                        <tr style={{ width: '100%' }}>
                            <td scope="col" style={{ width: '60%', fontSize: '1.0rem', paddingLeft: '30px', }}>Design Studio</td>
                            <td scope="col" style={{ width: '40%', fontWeight: 'bold', fontSize: '1.0rem', }}>{this.internalVersionLatest('Design Studio')}</td>
                        </tr>
                        <tr>
                            <td scope="col" style={{ width: '60%', fontSize: '1.0rem', paddingLeft: '30px' }}>HA Automation</td>
                            <td scope="col" style={{ width: '40%', fontWeight: 'bold', fontSize: '1.0rem', }}>{this.internalVersionLatest('HA Automation')}</td>
                        </tr>
                        <tr>
                            <td scope="col" style={{ width: '60%', fontSize: '1.0rem', paddingLeft: '30px', }}>Media</td>
                            <td scope="col" style={{ width: '40%', fontWeight: 'bold', fontSize: '1.0rem', }}>{this.internalVersionLatest('Media')}</td>
                        </tr>
                        <tr>
                            <td scope="col" style={{ width: '60%', fontSize: '1.0rem', paddingLeft: '30px' }}>Operating System</td>
                            <td scope="col" style={{ width: '40%', fontWeight: 'bold', fontSize: '1.0rem', }}>{this.internalVersionLatest('Operating System')}</td>
                        </tr>
                        <tr>
                            <td scope="col" style={{ width: '60%', fontSize: '1.0rem', paddingLeft: '30px', }}>Cloud Studio</td>
                            <td scope="col" style={{ width: '40%', fontWeight: 'bold', fontSize: '1.0rem', }}>{this.internalVersionLatest('Cloud Studio')}</td>
                        </tr>
                        <tr>
                            <td scope="col" style={{ width: '60%', fontSize: '1.0rem', paddingLeft: '30px', }}>iPad App</td>
                            <td scope="col" style={{ width: '40%', fontWeight: 'bold', fontSize: '1.0rem', }}>{this.internalVersionLatest('iPad App')}</td>
                        </tr>
                        <tr>
                            <td scope="col" style={{ width: '60%', fontSize: '1.0rem', paddingLeft: '30px' }}>WE.OKAS</td>
                            <td scope="col" style={{ width: '40%', fontWeight: 'bold', fontSize: '1.0rem' }}>{this.internalVersionLatest('WE.OKAS')}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>);
    }

    internalVersionLatest = (appName) => {
        let version = 'Yet to release';
        this.state.versionData.forEach((element) => {
            if (element.application_name === appName) {
                version = element.application_version
            }
        })
        return version
    }


    fetchInternalVersion = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/versioncontrol/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
               // console.log(data)
                this.setState({
                    versionData: data
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    aiDashboard = () => {
        return (
            <div class="col-12" style={{ height: '100%', width: '100%' }}>
                <div className="dashboard-card-heading">
                    <span>AI Dashboard</span>
                </div>
                <div className="ai-dashboard" style={{ height: '10vh', borderRadius: '15px' }}>

                </div>
            </div>
        );
    }
    render() {
        return (
            <div className="text-center dashboard-cover -4" style={{ backgroundColor: "#eff3f7", zIndex: '0', marginTop: '40px', }}>
                <div className="header-dashboard">
                    Welcome to OKAS CLOUD STUDIO!
                </div>
                <div className="Subheading-dashboard slideInOut animated">Tools from OKAS for great distributor, engaging with your users and possibilities.
                </div>
                <div className="container-fluid margin-top-custom">
                    <div className="row ">

                        {/* OKAS Logo Start */}

                        {["view", "add", "edit", "delete", "assign okas inventory"].some(action =>
                            is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "okas inventory", action)
                        ) ? (
                            // ✅ User has permission: clickable
                            <div
                                className="col-3 col-xs-12 logo-dashboard"
                                onMouseEnter={this.hoverEffectEnter.bind(this, 'ob')}
                                onMouseLeave={this.hoverEffectLeave.bind(this, 'ob')}
                            >
                                <Link to="/okasboxes/dashboard" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <img
                                        src={this.state.obImg}
                                        className="col-16"
                                        style={{ height: '150px', width: '150px', transform: 'scale(0.6)' }}
                                    />
                                    <div
                                        className={this.state.obHeading}
                                        style={{ marginTop: '1%', fontWeight: '500' }}
                                    >
                                        OKAS
                                    </div>
                                </Link>
                            </div>
                        ) : (
                            // ❌ No permission: show with tooltip, disable click
                            <Tooltip title="You don't have permission" arrow>
                                <div
                                    className="col-3 col-xs-12 logo-dashboard"
                                    onMouseEnter={this.hoverEffectEnter.bind(this, 'ob')}
                                    onMouseLeave={this.hoverEffectLeave.bind(this, 'ob')}
                                    style={{ cursor: 'not-allowed' }}
                                >
                                    <div>
                                        <img
                                            src={this.state.obImg}
                                            className="col-6"
                                            style={{ height: '150px', width: '150px', transform: 'scale(0.8)' }}
                                        />
                                        <div
                                            className={this.state.obHeading}
                                            style={{ marginTop: '1%', fontWeight: '500' }}
                                        >
                                            OKAS
                                        </div>
                                    </div>
                                </div>
                            </Tooltip>
                        )}


                        {/* Distributor Logo Start */}

                        {["view", "add", "edit", "delete"].some(action =>
                            is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "distributor", action)
                        ) ? (
                            // ✅ User has permission: normal clickable card
                            <div
                                className="col-3 col-xs-12 logo-dashboard"
                                onMouseEnter={this.hoverEffectEnter.bind(this, 'distributor')}
                                onMouseLeave={this.hoverEffectLeave.bind(this, 'distributor')}
                            >
                                <a href="/distributor" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <img
                                        src={this.state.distributorImg}
                                        className="col-16"
                                        style={{ height: '150px', width: '150px', transform: 'scale(1.2)' }}
                                    />
                                    <div
                                        className={this.state.distributorHeading}
                                        style={{ marginTop: '1%', fontWeight: '500' }}
                                    >
                                        Distributor
                                    </div>
                                </a>
                            </div>
                        ) : (
                            // ❌ No permission: disable interaction but show tooltip
                            <Tooltip title="You don't have permission" arrow>

                                <div
                                    className="col-3 col-xs-12 logo-dashboard"
                                    onMouseEnter={this.hoverEffectEnter.bind(this, 'distributor')}
                                    onMouseLeave={this.hoverEffectLeave.bind(this, 'distributor')}
                                    style={{ cursor: 'not-allowed' }}
                                >
                                    <div >
                                        <img
                                            src={this.state.distributorImg}
                                            className="col-16"
                                            style={{ height: '150px', width: '150px', transform: 'scale(1.2)' }}
                                        />
                                        <div
                                            className={this.state.distributorHeading}
                                            style={{ marginTop: '1%', fontWeight: '500' }}
                                        >
                                            Distributor
                                        </div>
                                    </div>
                                </div>

                            </Tooltip>
                        )}


                        {/* SystemIntegrator Logo start */}
                       
                        {["view", "add", "edit", "delete"].some(action =>
                            is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "si", action)
                        ) ? (
                            // ✅ Has permission: clickable
                            <div
                                className="col-3 col-xs-12 logo-dashboard"
                                onMouseEnter={this.hoverEffectEnter.bind(this, 'si')}
                                onMouseLeave={this.hoverEffectLeave.bind(this, 'si')}
                            >
                                <a href="/systemintegrator/system" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <img
                                        src={this.state.siImg}
                                        className="col-6"
                                        style={{ height: '150px', width: '150px', transform: 'scale(0.8)' }}
                                    />
                                    <div
                                        className={this.state.siHeading}
                                        style={{ marginTop: '1%', fontWeight: '500' }}
                                    >
                                        System Integrator
                                    </div>
                                </a>
                            </div>
                        ) : (
                            // ❌ No permission: show disabled card with tooltip
                            <Tooltip title="You don't have permission" arrow>
                                <div
                                    className="col-3 col-xs-12 logo-dashboard"
                                    onMouseEnter={this.hoverEffectEnter.bind(this, 'si')}
                                    onMouseLeave={this.hoverEffectLeave.bind(this, 'si')}
                                    style={{ cursor: 'not-allowed' }}
                                >
                                    <div style={{ pointerEvents: 'none' }}>
                                        <img
                                            src={this.state.siImg}
                                            className="col-6"
                                            style={{ height: '150px', width: '150px', transform: 'scale(0.8)' }}
                                        />
                                        <div
                                            className={this.state.siHeading}
                                            style={{ marginTop: '1%', fontWeight: '500' }}
                                        >
                                            System Integrator
                                        </div>
                                    </div>
                                </div>
                            </Tooltip>
                        )}

                        {/* Masterdevice Logo Start */}
                    
                        {["view", "add"].some(action =>
                            is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "master device", action)
                        ) ? (
                            // ✅ Has permission: clickable card
                            <div
                                className="col-3 col-xs-12 logo-dashboard"
                                onMouseEnter={this.hoverEffectEnter.bind(this, 'md')}
                                onMouseLeave={this.hoverEffectLeave.bind(this, 'md')}
                            >
                                <a href="/masterdevice/alldevice" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <img
                                        src={this.state.mdImg}
                                        className="col-6"
                                        style={{ height: '150px', width: '150px', transform: 'scale(0.8)' }}
                                    />
                                    <div
                                        className={this.state.mdHeading}
                                        style={{ marginTop: '1%', fontWeight: '500' }}
                                    >
                                        Master Devices
                                    </div>
                                </a>
                            </div>
                        ) : (
                            // ❌ No permission: show disabled card with tooltip
                            <Tooltip title="You don't have permission" arrow>
                                <div
                                    className="col-3 col-xs-12 logo-dashboard"
                                    onMouseEnter={this.hoverEffectEnter.bind(this, 'md')}
                                    onMouseLeave={this.hoverEffectLeave.bind(this, 'md')}
                                    style={{ cursor: 'not-allowed' }}
                                >
                                    <div style={{ pointerEvents: 'none' }}>
                                        <img
                                            src={this.state.mdImg}
                                            className="col-6"
                                            style={{ height: '150px', width: '150px', transform: 'scale(0.8)' }}
                                        />
                                        <div
                                            className={this.state.mdHeading}
                                            style={{ marginTop: '1%', fontWeight: '500' }}
                                        >
                                            Master Devices
                                        </div>
                                    </div>
                                </div>
                            </Tooltip>
                        )}

                    </div>
                </div>

                <div className="text-left " style={{ marginTop: '7%' }}>
                    <td style={{ width: '6.66%' }}></td>
                    <td style={{ width: '41.5%', overflowY: 'hidden', height: '100%' }}>{this.dashboardChart()}</td>
                    <td style={{ width: '3.66%' }}></td>
                    <td style={{ width: '41.5%', height: '100%' }}>{this.versionSection()}</td>
                    <td style={{ width: '6.66%' }}></td>
                </div>
              
                <div style={{ marginBottom: '20px', fontWeight: 'bold', marginTop: '20px' }}>
                    {/* Version: {this.internalVersionLatest('Cloud Studio')}  */}
                </div>
                <div className="modal">
                    <DoughnutChart />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        redux: state,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        deviceUpdate: (data) => dispatch({ type: ActionTypes.DEVICE, data: data }),
        deviceError: (data) => dispatch({ type: ActionTypes.DRIVERERROR, data: data }),
        deviceErrorClean: (data) => dispatch({ type: ActionTypes.DRIVERERRORCLEAN, data: data }),
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);